(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function updateCountdown(element) {
    const target = Date.parse(element.dataset.target || '');
    if (!target) {
      return;
    }

    const diff = target - Date.now();
    if (diff <= 0) {
      element.classList.add('is-expired');
      element.querySelectorAll('[data-countdown-value]').forEach((node) => {
        node.textContent = '00';
      });
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    element.querySelector('[data-countdown-value="days"]').textContent = pad(days);
    element.querySelector('[data-countdown-value="hours"]').textContent = pad(hours);
    element.querySelector('[data-countdown-value="minutes"]').textContent = pad(minutes);
    element.querySelector('[data-countdown-value="seconds"]').textContent = pad(seconds);
  }

  function bootCountdowns(root) {
    root.querySelectorAll('[data-eko-countdown]').forEach((element) => {
      updateCountdown(element);
      if (element.dataset.countdownBooted === 'true') {
        return;
      }
      element.dataset.countdownBooted = 'true';
      window.setInterval(() => updateCountdown(element), 1000);
    });
  }

  function bootImageCompare(root) {
    root.querySelectorAll('[data-eko-image-compare]').forEach((element) => {
      const input = element.querySelector('[data-compare-input]');
      if (!input) {
        return;
      }
      const update = () => {
        element.style.setProperty('--compare-position', `${input.value}%`);
      };
      update();
      if (input.dataset.compareBooted === 'true') {
        return;
      }
      input.dataset.compareBooted = 'true';
      input.addEventListener('input', update);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bootCountdowns(document);
    bootImageCompare(document);
  });
  document.addEventListener('shopify:section:load', (event) => {
    bootCountdowns(event.target);
    bootImageCompare(event.target);
  });
})();
